export enum OtpScope {
  RECEIPT_DOWNLOAD = 'RECEIPT_DOWNLOAD',
  PROFILE_UPDATE = 'PROFILE_UPDATE',
  PHONE_CHANGE = 'PHONE_CHANGE',
  PHONE_RECOVERY = 'PHONE_RECOVERY',
}
